import { Col, Row } from "antd";
import InfoCardComponent from "../../../components/InfoCardComponent";
import { Paquetes } from "../../../types/common";
import RechargePaymentAmount from "./PaymentAmount";
import PaymentCard, { CardRechargeProps } from "./PaymentCard";

interface RechargeWithCardInterface {
    pkg: Paquetes;
    doRecharge: (cardData: CardRechargeProps) => void
};

const RechargeWithCard = (props: RechargeWithCardInterface) => {
    const { pkg, doRecharge } = props;

    return (
        <div style={{ marginTop: 20 }}>
            <>
                <InfoCardComponent title="¡Estimado usuario!" description="Por el momento no aceptamos pagos con American Express." />
                <Row gutter={[16, 16]} style={{ marginTop: 20 }}>
                    <Col xs={24} xl={12}>
                        <RechargePaymentAmount price={pkg.monto} vigency={pkg.vigencia} />
                    </Col>
                    <Col xs={24} xl={12}>
                        <PaymentCard functionRecharge={doRecharge} />
                    </Col>
                </Row>
            </>
        </div>
    );
};

export default RechargeWithCard;
